import React from 'react';
// Components
import StoreMarginsPage from '../../components/StoreMargins/StoreMarginsPage';

const ManageOrganizationMargins: React.FC = () => {
  return (
    <StoreMarginsPage
      heading="Manage organization store margins"
      description="Adjust platform fees for this organization's store to override the default margins."
    />
  );
};

export default ManageOrganizationMargins;
